// src/components/Layout.jsx
import React from 'react';
import Sidebar from '../components/Admin2Sidebar';

const Layout = ({ children }) => {
  return (
    <div>
      <Sidebar />
      <div>
        {children}
      </div>
    </div>
  );
};

export default Layout;
